import { Component, HostListener, OnInit } from '@angular/core';
import { AuthService } from '@services/auth/auth.service';
import { SignoPlanService } from '@services/entidades/signo-planes.service';
import { SignoAuditoriaService } from '@services/auditoria/signo-auditoria.service';
import { GecrosAfiliadosService } from '@services/entidades/gecros-afiliados.service';
import { UsuarioService } from '@services/shared/usuario.service';
import { SignoPlan } from '@interfaces/interface-bakend/entidades/signo-plan.interface';
import { buscarPlanPorGecros } from '@shared/utils/plan.util';
import { User } from '@interfaces/interface-bakend/seguridad/users/user.interface';
import { environment } from '@env/environment';

const URL_BACKEND = environment.urlBackend;

@Component({
    selector: 'app-coseguros',
    templateUrl: './coseguros.component.html',
    styleUrls: ['./coseguros.component.scss'],
})
export class CosegurosComponent implements OnInit {

    loading = true;
    titular: User | null = null;
    signoPlan: SignoPlan | null = null;
    pdfUrl: string | null = null;
    sinDatosGecros = false;

    leyendaDefault = 'Consulte con su asesor para obtener mas informacion sobre los coseguros de su plan.';

    private pdfCargado = false;

    constructor(
        private authService: AuthService,
        private signoPlanService: SignoPlanService,
        private signoAuditoriaService: SignoAuditoriaService,
        private gecrosAfiliadosService: GecrosAfiliadosService,
        private usuarioService: UsuarioService,
    ) {}

    async ngOnInit(): Promise<void> {
        try {
            this.titular = await this.authService.getUserLogon();

            await this.sincronizarPlanDesdeGecros();

            if (this.sinDatosGecros) {
                this.loading = false;
                this.signoAuditoriaService.registrarEvento({
                    accion: 'PANTALLA_ACCESO',
                    modulo: 'Coseguros',
                    pantalla: 'Coseguros',
                    ruta: '/coseguros',
                    payload: { sinDatosGecros: true },
                    resultado: 'EXITO',
                });
                return;
            }

            if (!this.titular?.signoPlan) {
                this.loading = false;
                this.signoAuditoriaService.registrarEvento({
                    accion: 'PANTALLA_ACCESO',
                    modulo: 'Coseguros',
                    pantalla: 'Coseguros',
                    ruta: '/coseguros',
                    payload: { tienePlan: false },
                    resultado: 'EXITO',
                });
                return;
            }

            this.signoPlan = await this.signoPlanService.getPlanById(this.titular.signoPlan);

            if (this.signoPlan && this.signoPlan.activoDescarga && this.signoPlan.pdf) {
                this.pdfUrl = `${URL_BACKEND}/media/getUrlMediaPlanes/pdf/${this.signoPlan.pdf}#toolbar=0&navpanes=0&download=0`;
            }

            this.signoAuditoriaService.registrarEvento({
                accion: 'PANTALLA_ACCESO',
                modulo: 'Coseguros',
                pantalla: 'Coseguros',
                ruta: '/coseguros',
                payload: {
                    planId: this.signoPlan?._id,
                    planDenominacion: this.signoPlan?.denominacion,
                    tienePdf: !!(this.signoPlan?.activoDescarga && this.signoPlan?.pdf),
                },
                resultado: 'EXITO',
            });
        } catch (error) {
            console.error('Error al cargar datos del plan', error);
            this.signoAuditoriaService.registrarEvento({
                accion: 'PANTALLA_ACCESO',
                modulo: 'Coseguros',
                pantalla: 'Coseguros',
                ruta: '/coseguros',
                resultado: 'ERROR',
                status: 500,
            });
        } finally {
            this.loading = false;
        }
    }

    private async sincronizarPlanDesdeGecros(): Promise<void> {
        try {
            const dni = this.titular?.identificacion;
            if (!dni) {
                return;
            }

            const gecrosResp: any = await this.gecrosAfiliadosService.getAfiliadoByIdentificacion(dni);
            const afiliadoGecros = gecrosResp?.data?.[0];
            if (!afiliadoGecros || !afiliadoGecros.plan) {
                console.log(`[Coseguros] Sin datos GECROS para documento ${dni}`);
                this.sinDatosGecros = true;
                return;
            }

            const planes = await this.signoPlanService.getPlanes();
            const planMatch = buscarPlanPorGecros(afiliadoGecros.plan, planes) as SignoPlan;
            if (!planMatch) {
                console.warn(`[Coseguros] No se encontro plan local para plan GECROS "${afiliadoGecros.plan}"`);
                return;
            }

            await this.usuarioService.updateUser(this.titular!._id!, {
                signoPlan: planMatch._id,
                signoGecrosAfiliado: afiliadoGecros,
            });
            this.titular!.signoPlan = planMatch._id;
            console.log('[Coseguros] Plan actualizado desde GECROS:', planMatch.denominacion);
        } catch (error) {
            console.error('[Coseguros] Error al sincronizar plan desde GECROS:', error);
            this.sinDatosGecros = true;
        }
    }

    onPdfLoad(): void {
        if (this.pdfCargado || !this.signoPlan) {
            return;
        }
        this.pdfCargado = true;
        this.signoAuditoriaService.registrarEvento({
            accion: 'VISUALIZAR',
            recurso: 'PDFCoseguros',
            modulo: 'Coseguros',
            pantalla: 'Coseguros',
            ruta: '/coseguros',
            payload: {
                planId: this.signoPlan._id,
                planDenominacion: this.signoPlan.denominacion,
                pdfFilename: this.signoPlan.pdf,
            },
            resultado: 'EXITO',
        });
    }

    @HostListener('window:keydown', ['$event'])
    onKeyDown(event: KeyboardEvent): boolean {
        const key = event.key.toLowerCase();
        if ((event.ctrlKey || event.metaKey) && (key === 'p' || key === 's')) {
            event.preventDefault();
            return false;
        }
        return true;
    }

}
